import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarLink } from '../../../classes/models/link.model';

@Component({
  selector: 'authority-labs-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  @Input() links: NavbarLink[] = [];
  constructor(private route: ActivatedRoute) {}

  // ngAfterViewInit(): void {
  // this.route.fragment.pipe(take(1)).subscribe((fragment) => {
  //   this.scrollToElementById(null, fragment);
  // });
  // }

  scrollToElementById(event: Event, elmId: string): void {
    if (event) {
      event.stopPropagation();
    }
    const elm = document.getElementById(elmId);
    if (elm) {
      elm.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
